export const formatFilterSummary = (filters: string[]): string => {
	if (filters.length === 1) {
		return filters[0];
	}
	if (filters.length === 2) {
		return `${filters[0]} and ${filters[1]}`;
	}
	return `${filters.slice(0, -1).join(", ")}, and ${filters.at(-1)}`;
};

export const EMPTY_STATE_CONFIG = {
	icon: "filter-remove-outline" as const,
	title: "No matching items",
	getDescription: (filterSummary: string) =>
		`None of your session items match the selected ${
			filterSummary.includes(" and ") || filterSummary.includes(", ")
				? "filters"
				: "filter"
		} (${filterSummary}). Try adjusting or clearing filters to view more results.`,
	ctaLabel: "Clear filters",
};
